import React, { useState } from 'react';
import './feedback.css'
import { useParams } from 'react-router-dom';
import apis from '../../apis/api';
import { ls } from '../../localStorage';
const Feedback = () => {
  const [description, setDescription] = useState('');
  const [email, setEmail] = useState('');
  const [sendBug, setSendBug] = useState(false);

    window.addEventListener("message", (event) => {
    if (event.data.currentUser) {
      localStorage.setItem("currentUser", event.data.currentUser);
      const currentUser = JSON.parse(event.data.currentUser)
      const token = currentUser.token;
      ls.setToken(token);
    }
  });
  const currentUser = localStorage.getItem("currentUser");  

  const { type,id } = useParams();
  if (currentUser){ 
    var parsedUser = JSON.parse(currentUser);
  }

    const sendBugReportEmail = async () => {
    if (!description || !email) return; 
    setSendBug(true); // Start loading
    let placeholder = document.getElementById("myPhoto") as HTMLImageElement;
    const userData = {
      name:parsedUser.username,
      username: parsedUser.u_name, 
      school_name: parsedUser.school_name ? parsedUser.school_name : "",
      description: description,
      type: type, 
      type_id: id,
      email:email,
      image: placeholder.src
    };

    try {
      const data = await apis._sendBugReport(userData);
    } catch (error) {
      console.error("Error sending bug report:", error);
      alert("Failed to send bug report. Please try again.");
    } finally {
      setSendBug(true); 
    }
  };

 const closeCapture = () => {
    window.close();
  };
  
  return (
    <div className="bug_reports">
      <div className="row">
        <div className="col-xs-12 col-sm-8 col-md-9 col-lg-9 text_center">
          <img className="bug_img" src="" alt="Bug Image" id="myPhoto" />
        </div>
        <div className="col-xs-12 col-sm-4 col-md-3 col-lg-3">
          <div className="feedback_heading">
            <div className="feedback_text">Your Feedback</div>
          </div>
          <div className="quiz_maker_bg gray_bg padding_1">
            <form >
              <textarea
                className="capture_input bug_textbox"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Is there a bug in this question? Please send us an email with a comment. If you accidentally pressed on the camera button, please press cancel ...."
                cols={30}
                rows={10}
                required
              />
              <input
                className="capture_input bug_email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                maxLength={70}
                placeholder="Your Email"
                required
              />
              {/* <div style={{width:"100%", display:"flex", justifyContent:"flex-end"}} > */}
              <div className=" btn_container">
                  <button
                    type="button"
                    className="save_popup_btn"
                    onClick={sendBugReportEmail}
                    disabled={!description || !email || sendBug}
                  >
                    Send Email
                  </button>
                  <button
                    type="button"
                    className="save_popup_btn cancel_bug"
                    onClick={closeCapture}
                  >
                    Cancel
                  </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
